/**
 * A organização da Pró Médico é a empresa atual (schema public / is_home).
 * Outras organizações não herdam loja, compras da loja nem Propósito em ação.
 */
export function isHomeOrganization(organizations, schema) {
  const current = schema || 'public'
  const match = (organizations || []).find((org) => org.schema_name === current)
  if (match && typeof match.is_home === 'boolean') return match.is_home
  return current === 'public'
}
